import { message } from 'antd';
import { apiFetch } from './../../common/helpers';
import { onSuccess, isBusy } from 'actionware';
import { onError } from 'actionware/lib/listeners';

export async function submitResetPassword(values) {
  return apiFetch('reset-password', 'POST', values);
}

export async function checkToken(token) {
  return apiFetch(`user/check-forgot-token/${token}`, 'GET')
}

onSuccess(submitResetPassword, async ({ store: { dispatch, getState } }) => {
  const { resetPassword: { newPassword } } = getState();
  message.success('Your password has been successfully reset.');
});

onError(checkToken, ({ error }) => {
  message.error('Change password link is not valid')
})